import { render, staticRenderFns } from "./CdlSaudeCadastroFinal.vue?vue&type=template&id=15f6a84b&scoped=true&"
import script from "./CdlSaudeCadastroFinal.vue?vue&type=script&lang=js&"
export * from "./CdlSaudeCadastroFinal.vue?vue&type=script&lang=js&"
import style0 from "./CdlSaudeCadastroFinal.vue?vue&type=style&index=0&id=15f6a84b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6a84b",
  null
  
)

export default component.exports